/* eslint-disable */
import api from "@/api";
import router from "@/router";
import {defineStore} from "pinia/dist/pinia";
import packageJson from "../../package.json";
import {useUserStore} from "@/stores/user";
import {client} from '@/stores/client.js'

export const useTransactionStore = defineStore('transaction', {
    state: () => ({
        paymentMethods: [],
        transactions : []
    }),
    getters: {
        getPaymentMethods(state) {
            return state.paymentMethods;
        },
        getTransactions(state) {
            return state.transactions;
        },
    },
    actions: {
        async action_getTransactions() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10083,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            return await api.post('', request)
                .then((res) => {
                    if (res.status === 200) {
                        return res.data
                    } else {
                        console.log('response is ' + res.status)
                    }
                }).then((data) => {
                    //console.log('getTransactions', data)
                    if (data.response === 100) {
                        this.transactions = data.account.transactions
                    } else if (data.response === -100002) {
                        userStore.resetUser('your credential is expired');
                        router.push({name: 'Login'})
                    }
                })

        },
    },
})

